export const guildScrollbarCss = {
  '&::-webkit-scrollbar': {
    width: '0',
  },
};
